import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Card, CardBody, Col, Container, Row } from "reactstrap";

import BreadCrumb from "../../../../Components/Common/BreadCrumb";

const Billing = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("billing.pageTitle");
  }, [t]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={t("billing.breadcrumb.title")} pageTitle={t("billing.breadcrumb.pageTitle")} />
        <Row className="justify-content-center">
          <Col lg={8} xl={6}>
            <Card>
              <CardBody className="p-4">
                <Alert color="warning" className="mb-4">
                  {t("billing.suspended.alert")}
                </Alert>
                <h4 className="mb-3">{t("billing.suspended.title")}</h4>
                <p className="text-muted mb-2">{t("billing.suspended.message")}</p>
                <p className="text-muted mb-0">{t("billing.suspended.description")}</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Billing;
